import React, { Component } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import HomeV1 from "./components/home-v1";
import { hydrateSession } from "./utils/rememberMe";

import AboutUs from "./components/about";

import TourListV2 from "./components/tour-list-v2";

import TourDetails from "./components/tour-details";
import DestinationLIst from "./components/destination-list";
import DestinationDetails from "./components/destination-details";

import GalleryDetails from "./components/gallery-details";
import Faq from "./components/faq";
import Contact from "./components/contact";
import Error from "./components/error";
import CommingSoon from "./components/comming-soon";
import UserProfile from "./components/user-profile";
import BookingDetailsPage from "./components/booking-details-page";
import FindBookingPage from "./components/find-booking";
import Blog from "./components/blog";
import BlogV2 from "./components/blog-v2";
import BlogV3 from "./components/blog-v3";
import BusinessServicesPage from "./components/business-services";
import Login from "./components/Login";
import Signup from "./components/Signup";
import ForgotPassword from "./components/ForgotPassword";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import { SuggestProvider } from "./components/SuggestProvider";
import { LoaderProvider } from "./components/LoaderProvider";
import Transfer from "./components/transfer";

import { CartProvider } from "./components/CartProvider";
import { CartCounterProvider } from "./components/CartCounterProvider";
import CartCustom from "./components/cart-custom";
import SpecialExursions from "./components/special-excursions";
import SpecialExcursion from "./components/special-excursion";
import { Toaster } from "react-hot-toast";
import SpecialExcursionDetails from "./components/special-excursion-details";
import Maintenance from "./components/maintenance";
import LegalPage from "./components/legal-page";
import CookieBanner from "./components/global-components/cookie-banner";

// Flip to false to bring the full site back.
const MAINTENANCE_MODE = true;

class Root extends Component {
  // The static #preloader splash screen in public/index.html used to only
  // ever get dismissed by main.js's `$(window).on('load', ...)` handler,
  // dynamically injected by Footer/FooterV2's componentDidMount - a race
  // against the real window 'load' event (images, fonts, etc. finishing)
  // that it could lose on a slower page, leaving the spinner stuck forever,
  // and a page with no Footer at all (AuthWrapper - /login, /signup,
  // /forgot-password) never injected main.js in the first place, so it was
  // *always* stuck there. Dismissing it here instead - once, synchronously
  // after the very first real render, regardless of route or which
  // components happen to mount - removes both failure modes.
  componentDidMount() {
    const preloader = document.getElementById("preloader");
    if (preloader) preloader.style.display = "none";
  }

  render() {
    return (
      <BrowserRouter basename="/">
        <Toaster position="top-center" reverseOrder={false} />
        <SuggestProvider>
          <LoaderProvider>
            <CartCounterProvider>
              <CartProvider>
                <div>
                  <Switch>
                    <Route exact path="/" component={HomeV1} />
                    {/* <Route path='/home-v2' component={HomeV2} />
            <Route path='/home-v3' component={HomeV3} /> */}
                    <Route path="/about" component={AboutUs} />
                    {/* <Route path='/tour-list' component={TourList} /> */}
                    <Route path="/tours-list" component={TourListV2} />
                    {/* <Route path='/tour-list-v3' component={TourListV3} /> */}
                    <Route path="/tour-details/:id?" component={TourDetails} />
                    <Route
                      path="/destination-list"
                      component={DestinationLIst}
                    />
                    <Route path="/transfer-services" component={Transfer} />
                    <Route
                      path="/destination-details/:id"
                      component={DestinationDetails}
                    />
                    {/* <Route path='/gallery' component={Gallery} /> */}
                    <Route path="/gallery" component={GalleryDetails} />
                    <Route path="/faq" component={Faq} />
                    <Route path="/contact" component={Contact} />
                    <Route path="/error" component={Error} />
                    <Route path="/comming-soon" component={CommingSoon} />
                    <Route path="/user-profile" component={UserProfile} />
                    <Route
                      path="/booking-details/:kind(booking|transfer)/:id"
                      component={BookingDetailsPage}
                    />
                    <Route path="/blog" component={Blog} />
                    <Route path="/blog-v2" component={BlogV2} />
                    <Route path="/blog-v3" component={BlogV3} />
                    <Route path="/business-Services" component={BusinessServicesPage} />
                    <Route path="/login" component={Login} />
                    <Route path="/signup" component={Signup} />
                    <Route path="/forgot-password" component={ForgotPassword} />
                    <Route path="/cart" component={CartCustom} />
                    <Route path="/find-booking" component={FindBookingPage} />
                    <Route
                      path="/special-excursions/:id"
                      component={SpecialExcursion}
                    />
                    <Route
                      path="/special-excursions/"
                      component={SpecialExursions}
                    />
                    <Route
                      path="/special-excursion-details"
                      component={SpecialExcursionDetails}
                    />
                    <Route path="/legal/:slug" component={LegalPage} />
                    {/* <Route patch= */}
                    {/* <Route path='/tour-details/:id' children={<TourDetails />} /> */}
                  </Switch>
                </div>
              </CartProvider>
            </CartCounterProvider>
          </LoaderProvider>
        </SuggestProvider>
        <CookieBanner />
      </BrowserRouter>
    );
  }
}

export default Root;

hydrateSession();

const container = document.getElementById("root");
const root = createRoot(container);
root.render(MAINTENANCE_MODE ? <Maintenance /> : <Root />);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register();
